import { gql } from 'react-apollo';

export const resetStats = gql`
  mutation resetStats($input: ResetStatsInput!) {
    resetStats(input: $input) {
      church {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/statistics/mutations/resetStats.js